import Vue from "vue"
import moment from "moment";

Vue.filter("date", date => moment(Date.parse(date)).format("MM/DD/YYYY"))
Vue.filter("dateTime", date => moment(Date.parse(date)).format("MM-DD-YYYY H:mm"))
Vue.filter("round", value => Number(Math.round(value+"e1")+"e-1"))
Vue.filter("hours", minutes => moment()
    .startOf("day")
    .add(minutes, "minutes")
    .format("HH:mm"))